<template>
  <ValidationProvider :rules="{ required: true }" slim v-slot="{ errors, passed, failed }">
    <div :class="[failed && 'lib__field--error', passed && (value.description !== null && value.description !== '') && 'lib__field--valid']" class="lib__field">
      <div class="lib__tiles lib__tiles--inline">
        <TileRadio group="contactType"
                    item="individual"
                    :label="$t('common.contact.type.individual')"
                    v-model="selection"
                    :disabled="isPrivateDisabled"
                    data-cy="tile-individual-contact"></TileRadio>
        <TileRadio group="contactType"
                    item="freelanceOrCompany"
                    :label="$t('common.contact.type.freelanceOrCompany')"
                    v-model="selection"
                    :disabled="isProfessionalDisabled"
                    data-cy="tile-freelance-or-company-contact"></TileRadio>
        <TileRadio group="contactType"
                    item="publicAuthority"
                    :label="$t('common.contact.type.publicAuthority')"
                    v-model="selection"
                    :disabled="isProfessionalDisabled"
                    data-cy="tile-public-authority-contact"></TileRadio>
      </div>
      <error-message :error="errors[0]" data-cy="contact-type-error-message"></error-message>
    </div>
  </ValidationProvider>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { ContactType } from '@/models/common/contact'

@Component({
  name: 'contact-type-selector'
})
export default class ContactTypeSelector extends Vue {
  //#region [Property]
  @Prop({ type: String, required: false }) public readonly value!: ContactType | null
  @Prop({ type: Boolean, required: false, default: false }) public readonly lockContactType!: boolean
  //#endregion

  //#region [Computed]
  public get selection(): ContactType | null {
    return this.value
  }

  public set selection(val: ContactType | null) {
    this.change(val)
  }

  public get isPrivateDisabled(): boolean {
    return this.lockContactType && this.value !== null && this.value !== 'individual'
  }

  public get isProfessionalDisabled(): boolean {
    return this.lockContactType && this.value !== null && this.value === 'individual'
  }
  //#endregion

  //#region [Emit]
  @Emit('input')
  public change(value: ContactType | null): ContactType | null {
    return value
  }
  //#endregion
}
</script>
